/**
 * @generated SignedSource<<36862798cd5f965de790d77c79b29817>>
 * @relayHash 7501d6397ea5d38a684af2d30aa676c5
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/360.0.0-2022-04-07T16:25:40.090Z/completeAccountEmailMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CompleteAccountEmailInput = {
  email: string;
  clientMutationId?: string | null;
};
export type completeAccountEmailMutation$variables = {
  input: CompleteAccountEmailInput;
};
export type completeAccountEmailMutation$data = {
  readonly completeAccountEmail: {
    readonly message: string | null;
  } | null;
};
export type completeAccountEmailMutation = {
  variables: completeAccountEmailMutation$variables;
  response: completeAccountEmailMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CompleteAccountEmailPayload",
    "kind": "LinkedField",
    "name": "completeAccountEmail",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "completeAccountEmailMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "completeAccountEmailMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "ferrum/360.0.0-2022-04-07T16:25:40.090Z/completeAccountEmailMutation",
    "metadata": {},
    "name": "completeAccountEmailMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "883b4525d2b17ac04896e764ae2e1f1b";

export default node;
